


























import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import DocumentRepoInput from '@/components/DocumentRepoList/DocumentRepoInput.vue';
import List from '@/components/Common/List.vue';
import DocumentRepoCard from '@/components/DocumentRepoList/DocumentRepoCard.vue';

export default Vue.extend({
  name: 'DocumentRepoList',
  components: {
    List,
    DocumentRepoInput,
    DocumentRepoCard,
  },
  data() {
    return {
      documentReposPerLine: 3,
      isComponentModalActive: false,
    };
  },
  computed: mapState('documentRepo', ['documentRepos']),
  methods: mapActions('documentRepo', ['loadDocumentRepos', 'clearDocumentRepo']),
  mounted() {
    this.loadDocumentRepos();
    this.clearDocumentRepo();
  },
});
